import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import "./App.css";
import WeatherSearch from "./WeatherSearch.js";

export default function App() {
  return (
    <div className="App">
      <WeatherSearch defaultCity="New York" />
      <div>
        <a
          className="codedBy"
          href="https://github.com/jcarlin28/react_weather_app"
        >
          Coded by Jessica Carlin
        </a>
        <br />
      </div>
    </div>
  );
}
